export class QueryCollection<T> extends Array<T> {
  constructor(items: Array<T>) {
    super();
    if (Array.isArray(items)) {
      items.forEach(item => this.push(item));
    }
  }

  get first(): T {
    return this.at(0)!;
  }

  get last(): T {
    return this.at(this.length - 1)!;
  }

  any(): boolean {
    return this.length > 0;
  }
}
